import { useState } from 'react';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AuthLayout from '../components/AuthLayout';
import AuthComponent from '../components/AuthComponent';
import { subscriptionStatus, subscriptionExpiry } from '../utils/data';
import { StripeSignupCheckoutUrl } from '../utils/network';

interface SignupData {
  name: string;
  email: string;
  requestedRole?: string;
  fullname?: string;
  role?: string;
}

const ROLE_CONFIG = {
  Admin: {
    label: "Admin",
    description: "Full system access and user management",
  },
  User: {
    label: "User",
    description: "Standard user access with basic operations",
  },
};

function RequestAccount() {
  const [loading, setLoading] = useState(false);
  const [errorModal, setErrorModal] = useState<{
    visible: boolean;
    message: string;
  }>({
    visible: false,
    message: ''
  });
  const navigate = useNavigate();

  const handleSubmit = async (values: SignupData) => {
    setLoading(true);
    try {
      const payload = {
        email: values.email,
        fullname: values.name || values.fullname || '',
        role: values.requestedRole || values.role || 'User',
      };

      const response = await axios.post(StripeSignupCheckoutUrl, payload);

      const checkoutUrl = response.data?.checkout_url || response.data?.url || response.data?.checkoutUrl;

      if (checkoutUrl) {
        window.open(checkoutUrl, '_blank', 'noopener,noreferrer');
      } else {
        localStorage.setItem(subscriptionStatus, 'trialing');
        const expiry = new Date();
        expiry.setDate(expiry.getDate() + 7);
        localStorage.setItem(subscriptionExpiry, expiry.toISOString());
        window.location.href = '/payment-success?session_id=mock_session_123&flow=signup';
      }
    } catch (error: any) {
      console.error('Submit error:', error);
      const errorMsg = error?.response?.data?.error || error?.response?.data?.detail || error?.response?.data?.message || 'Failed to initiate checkout. Please try again.';
      setErrorModal({
        visible: true,
        message: errorMsg
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <AuthComponent
        titleText="Sign Up &"
        titleSpanText="Subscribe"
        subtitleText=""
        bottonText="Claim 7-Day Free Trial"
        onSubmit={handleSubmit}
        loading={loading}
        isSignup={true}
        isPassword={false}
        roleConfig={ROLE_CONFIG}
        showBackArrow={true}
        onBackClick={() => navigate('/login')}
        initialValues={{ requestedRole: 'User' }}
        hideSignupLink={true}
        noteText="Note: You will be charged for your subscription plan automatically after the free trial ends."
        errorMsg={errorModal.visible ? errorModal.message : null}
        onErrorClose={() => setErrorModal({ visible: false, message: '' })}
      />
    </AuthLayout>
  );
}

export default RequestAccount;
